import React, { useEffect, useState } from "react";
import { Grid, TextField, Button, Box } from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import DropdownSelector from "../../atoms/Common/DropdownSelector";
import { getCatalogue } from "../../api/common/catalogues.ts";
import { useSnack } from "../../services/SnakbarProvider";
import { handleError } from "../../services/errorHandler";

const AssetForm = ({ onSubmit, onCancel, initialValues = null, companyId }) => {
  const { openSnack } = useSnack();
  const [assetTypeOptions, setAssetTypeOptions] = useState([]);

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required("El nombre es requerido")
      .min(2, "El nombre debe tener al menos 2 caracteres"),
    code: Yup.string()
      .required("El código es requerido")
      .min(1, "El código es requerido"),
    assetTypeId: Yup.number()
      .required("El tipo de activo es requerido")
      .positive("Debe seleccionar un tipo de activo válido"),
  });

  const defaultValues = {
    name: "",
    code: "",
    assetTypeId: "",
    companyId: companyId,
  };

  const fetchAssetTypes = async () => {
    try {
      const res = await getCatalogue({ CatalogueName: "ASSET_TYPE" });
      setAssetTypeOptions(res.data);
    } catch (e) {
      openSnack(handleError(e), "error");
    }
  };

  useEffect(() => {
    fetchAssetTypes();
  }, []);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      await onSubmit(values);
    } catch (error) {
      openSnack(handleError(error), "error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={initialValues || defaultValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, values, setFieldValue }) => (
        <Form>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <DropdownSelector
                name="assetTypeId"
                label="Tipo de Activo"
                optionLabel="name"
                fetchFunction={getCatalogue}
                fetchParams={{ CatalogueName: "ASSET_TYPE" }}
                keyField="id"
                required
              />
            </Grid>
            <Grid item xs={4}>
              <Field
                name="name"
                as={TextField}
                label="Nombre del Activo"
                fullWidth
                variant="outlined"
                required
              />
            </Grid>
            <Grid item xs={4}>
              <Field
                name="code"
                as={TextField}
                label="Código del Activo"
                fullWidth
                variant="outlined"
                required
              />
            </Grid>

            <Grid item xs={12}>
              <Box display="flex" justifyContent="flex-end" gap={2}>
                <Button
                  type="button"
                  variant="outlined"
                  onClick={onCancel}
                  disabled={isSubmitting}
                >
                  Cancelar
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Guardando..." : "Guardar"}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default AssetForm;
